/* Progressive enhancement only. Core browsing, links, FAQs and signup do not require this file. */
(() => {
  'use strict';
  if (window.kkBookshopInitialized) return;
  window.kkBookshopInitialized = true;
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    // Close a paperback dropdown when the reader clicks elsewhere.
    document.querySelectorAll('.kk-paperback[open]').forEach((details) => {
      if (!details.contains(target)) details.open = false;
    });
    const link = target.closest('.kk-nav-drawer a');
    if (!link) return;
    const drawer = link.closest('header-drawer');
    if (drawer && typeof drawer.closeMenuDrawer === 'function') {
      const summary = drawer.querySelector(':scope > details > summary');
      if (summary) {
        drawer.closeMenuDrawer(event, summary);
        summary.setAttribute('aria-expanded', 'false');
      }
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.kk-paperback[open]').forEach((details) => {
      const focusWasInside = details.contains(document.activeElement);
      details.open = false;
      if (focusWasInside) details.querySelector('summary')?.focus();
    });
  });
  // Keep only one paperback country menu open. Uses capture because toggle does not bubble.
  document.addEventListener('toggle', (event) => {
    const current = event.target;
    if (!(current instanceof HTMLDetailsElement) || !current.matches('.kk-paperback') || !current.open) return;
    document.querySelectorAll('.kk-paperback[open]').forEach((details) => {
      if (details !== current) details.open = false;
    });
  }, true);
})();
/* A spoiler-free example only. Delegation supports Shopify's section re-rendering. */
(() => {
  'use strict';
  if (window.kkMiniPuzzleReady) return;
  window.kkMiniPuzzleReady = true;
  const clues = [
    'The final word has exactly five letters.',
    'The first word contains the letter A.',
    'Both words have the same number of letters.'
  ];
  const removals = [1, 3, 0];
  const reasons = [
    'Cottage has seven letters, so Birch Cottage is out.',
    'Willow has no A, so Willow Lodge is out.',
    'Oak has three letters and House has five, so Oak House is out.'
  ];
  const render = (root, step, message = '') => {
    root.dataset.step = String(step);
    root.querySelector('[data-mini-count]').textContent = step < 3 ? `0${step + 1} / 03` : 'CASE CLOSED';
    root.querySelector('[data-mini-label]').textContent = step < 3 ? `CLUE ${step + 1}` : 'YOUR FIRST LITTLE WIN';
    root.querySelector('[data-mini-text]').textContent = step < 3 ? clues[step] : 'Maple House is the one that fits.';
    root.querySelector('.kk-mini-direction').hidden = step === 3;
    root.querySelector('[data-mini-end]').hidden = step !== 3;
    root.querySelector('[data-mini-status]').textContent = message || 'Four possibilities. Only one place fits all three clues.';
    root.querySelectorAll('[data-mini-option]').forEach((button) => {
      const i = Number(button.dataset.miniOption);
      const crossed = removals.slice(0, step).includes(i);
      button.classList.toggle('is-crossed', crossed);
      button.classList.toggle('is-answer', step === 3 && i === 2);
      button.setAttribute('aria-pressed', String(crossed));
      button.disabled = crossed || step === 3;
      button.setAttribute('aria-label', `${button.querySelector('span:nth-child(2)').textContent}${crossed ? ' — crossed out' : step === 3 ? ' — the answer' : ''}`);
    });
  };
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const root = target.closest('[data-kk-mini]');
    if (!root) return;
    if (target.closest('[data-mini-reset]')) {
      render(root, 0);
      root.querySelector('[data-mini-clue]').focus({ preventScroll: true });
      return;
    }
    const button = target.closest('[data-mini-option]');
    if (!button || button.disabled) return;
    const step = Number(root.dataset.step || 0);
    if (step >= 3) return;
    if (!root.dataset.miniStarted) {
      root.dataset.miniStarted = 'true';
      document.dispatchEvent(new CustomEvent('kk:funnel', {detail:{action:'mini_puzzle_started'}}));
    }
    if (Number(button.dataset.miniOption) !== removals[step]) {
      root.querySelector('[data-mini-status]').textContent = 'That place still fits this clue. Cross out the one that doesn’t.';
      return;
    }
    if (step === 2 && !root.dataset.miniCompleted) {
      root.dataset.miniCompleted = 'true';
      document.dispatchEvent(new CustomEvent('kk:funnel', {detail:{action:'mini_puzzle_completed'}}));
    }
    render(root, step + 1, step === 2 ? 'Four possibilities became one. Imagine a whole book of little discoveries like this.' : reasons[step] + ' Now try the next clue.');
    root.querySelector('[data-mini-clue]').focus({ preventScroll: true });
  });
})();

/* Local integration hooks only. No analytics provider or tracking cookies are installed. */
(() => {
 if (window.kkFunnelHooksReady) return;
 window.kkFunnelHooksReady = true;
 document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const link = target?.closest('[data-kk-track]');
  if (link) document.dispatchEvent(new CustomEvent('kk:funnel', {detail:{action:link.dataset.kkTrack,book:link.dataset.kkBook || '',label:link.dataset.kkLabel || ''}}));
 });
})();
